import * as Api from '@ViewModels';
import { StyleDeclarationValue, css } from 'aphrodite';
import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { ILocationState } from '../../../../models';
import { useEventLogging } from '../../../../models/Logging';
import { useErrorMessages, useFullscreenModal, useUserSession } from '../../../../models/hooks/appStateHooks';
import { AdminUserSessionContext, IndustryAutomationTemplateViewModel } from '../../../../viewmodels/AdminViewModels';
import { LoadingSpinner } from '../../../../web/components/LoadingSpinner';
import { CreateAdminAutomationTemplatePage } from '../../../../web/containers/CreateAutomationTemplate';
import { INavigationItemProps } from '../../../../web/containers/MainContainer';
import { baseStyleSheet } from '../../../../web/styles/styles';
import { styleSheet } from './styles';

interface IProps extends RouteComponentProps<any>, INavigationItemProps {
	className?: string;
	styles?: StyleDeclarationValue[];
}

export const CreateIndustryAutomationTemplate: React.FC<IProps> = props => {
	const { className, styles = [] } = props;
	const fullscreenModal = useFullscreenModal();
	const { logEvent, logApiError } = useEventLogging('CreateIndustryAutomationTemplate');
	const userSession = useUserSession<AdminUserSessionContext>();
	const errorMessages = useErrorMessages();
	const [loading, setLoading] = React.useState<boolean>(false);

	const onRequestEdit = React.useCallback(
		(automationTemplate: Api.AutomationTemplateViewModel) => {
			setLoading(true);
			IndustryAutomationTemplateViewModel.fromAutomationTemplate(userSession, automationTemplate)
				?.then(template => {
					const locationState: ILocationState<IndustryAutomationTemplateViewModel, any> = { viewModel: template };

					logEvent('EditTemplate', { id: template.id });
					fullscreenModal?.history.push({
						pathname: `/automations/${template.id}`,
						state: locationState,
					});
				})
				?.catch(error => {
					errorMessages.pushApiError(error);
					logApiError('CreateTemplate-Error', error);
					setLoading(false);
				});
			return true;
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[fullscreenModal, userSession]
	);

	return (
		<div className={`${css(styleSheet.container, ...styles)} create-industry-automation-template ${className || ''}`}>
			<CreateAdminAutomationTemplatePage onRequestEdit={onRequestEdit} />
			{!!loading && <LoadingSpinner className={css(baseStyleSheet.absoluteCenter)} type='large' />}
		</div>
	);
};
